<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">New Clickable area</p>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label class="label ">Label</label>
          <input class="input" v-model="label" placeholder="Name">
          <label class="label ">URL</label>
          <input class="input" v-model="url" placeholder="URL">
          <div class="is-flex input-limit-container">
          <toggle-switch v-model="isVideo"></toggle-switch>
          <label class="label limit-label">Video</label>
          </div>
        </div>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
      </section>
      <div class="modal-card-foot is-flex">
        <div class="modal-buttons">
          <button class="button is-primary is-uppercase ml-3" @click="close()">{{ 'Done' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'
export default {
  mixins: [componentState],
  props: ['rectIndex'],
  components: {
    ToggleSwitch
  },
  data: function () {
    return {
      active: false,
      errorMessage: '',
      rectangleParams: {},
      isVideo: false,
      url: '',
      label: ''
    }
  },
  mounted: function () {
  },
  computed: {
  },
  watch: {
    active: function (active) {
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    }
  },
  methods: {
    cancel: function () {
      this.$emit('modalCancel')
      this.close()
    },
    close: function () {
      this.rectangleParams.url = this.url
      this.rectangleParams.isVideo = this.isVideo
      this.rectangleParams.label = this.label
      this.rectangleParams.rectIndex = this.rectIndex
      this.$emit('rectangleParams', this.rectangleParams)
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.modal-card {
  text-align: center;
  overflow: hidden;
  .title {
    border-bottom: 1px solid #DCDCDC;
    padding: 1.3rem 0;
    font-weight: normal;
    width: 100%;
  }
  .close-button {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1.25rem;
    top: 0.5rem;
    border: none;
  }
  .submit-questions {
    margin-top: 1rem;
  }
  .modal-card-body {
    height: 100%;
    padding: 2rem 3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .modal-card-head {
    padding-left: 0;
    padding-right: 0;
  }
  .modal-card-foot {
    justify-content: center;
  }
  .field {
    padding-bottom: 1rem;
    width: 19rem;
    text-align: left;
  }
  input {
    margin-bottom: 1rem;
  }
  .limit-label{
    margin-left: 1.5rem;
  }
}
</style>
